import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { useForm } from 'react-hook-form';
import { merchantOrderValidationForm } from '../../utils/validationSchema';
import ComboboxInput from '../Reusable/Form/ComboboxInput';
import APIS from '../../constant/EndPoint';
import FilterOrderList from './FilterOrderList';
import Form from '../../layouts/Form';
import Modal from '../Reusable/Modal';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Button from '../Reusable/Button';
import useGetHook from '../../customHooks/useGetHook';
import Spinner from '../Reusable/Spinner';


const ConfirmMessage = (props: any) => {
  const { selectedOrder, handleCreate, isPostLoading, getValues } = props
  const { data, isLoading } = useGetHook({
    queryKey: [selectedOrder],
    url: `${APIS.ORDER}invoice-report/`,
    params: {
      id__in: selectedOrder.startsWith(",") ? selectedOrder.slice(1) : selectedOrder
    },
  });

  return (
    <>{isLoading ? <Spinner /> : <>
      <div className='flex justify-between mt-8'>
        <div>Total Number of order:</div>
        <div>{data?.total_order}</div>
      </div>
      <div className='flex justify-between mt-2'>
        <div>Total Collected COD:</div>
        <div>{data?.collected_cod}</div>
      </div>
      <div className='flex justify-between mt-2'>
        <div>Commision:</div>
        <div>{data?.commission}</div>
      </div>
      <div className='flex justify-between mt-2'>
        <div>Total Delivery Charge:</div>
        <div>{data?.delivery_charge}</div>
      </div>
      <div className='flex justify-between mt-2'>
        <div>Total Tax Amount:</div>
        <div>{data?.tax_amount}</div>
      </div>
      <div className='flex justify-between mt-2'>
        <div>Total Amount After Tax:</div>
        <div>{data?.amount_after_tax}</div>
      </div>
      <div className='flex justify-between mt-2 font-bold'>
        <div>Net Payable</div>
        <div>{data?.payable_amount}</div>
      </div>
      <div className="flex justify-end w-full">
        <div className="w-[150px] mt-4">
          <Button label={"Generate Invoice"} onClick={()=>handleCreate(getValues())} isLoading={isPostLoading} />
        </div>
      </div>
    </>}

    </>
  )
}


const CreateInvoice = (props: any) => {
  const [searchParams, setSearchParms] = useSearchParams()
  const [openConfirmMessage, setOpenConfirmMessage] = useState(false)
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    getValues,
    watch,
    clearErrors
  } = useForm<any>({
    resolver: yupResolver(merchantOrderValidationForm),
  });

  const { handleCreate, isLoading } = props;

  let merchant = watch("merchant")

  const handleOpenPopup = () => {
    const selectedOrder = searchParams.get("selectedItems")?.split(",")
    if (!selectedOrder?.length) {
      toast.error("Please select at least one order")
      return
    }
    setOpenConfirmMessage(true)
  }

  return (
    <>
      <Form
        handleSubmit={handleSubmit}
        handleFormSubmit={handleOpenPopup}
        setError={setError}
        buttonLabel={"Create"}
        isLoading={props?.isPostLoading}
      >
        <div className='w-full'>
          <ComboboxInput
            url={APIS.MERCHANT}
            props={{}}
            queryKey={"merchant"}
            register={register("merchant")}
            errors={errors?.merchant}
            name={"merchant"}
            label={"Merchant"}
            setValue={setValue}
            placeholder={"Search Merchant"}
            getValues={getValues}
            clearErrors={clearErrors}
          />
        </div>
      </Form>
      {merchant ? <FilterOrderList
        API={`${APIS.MERCHANT}${merchant}/invoice-orders/`}
      /> : ""}

      <Modal
        isOpen={openConfirmMessage}
        setIsOpen={setOpenConfirmMessage}
        title={"Are you sure you want to create invocie?"}
        children={<>
          <ConfirmMessage
            handleCreate={handleCreate}
            isPostLoading={isLoading}
            getValues={getValues}
            selectedOrder={searchParams.get("selectedItems")}
          />
        </>}
      />
    </>
  )
}

export default CreateInvoice
